import React, { useEffect } from 'react'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import 'react-tabs/style/react-tabs.css'
import { setSelectedToolbarTabIndex } from '../../store/ui/uiSlice'
import ScrollButtons from '../ScrollButtons/ScrollButtons'
import EditItemPanel from '../EditItemPanel/EditItemPanel'
import * as Styled from './styles'
import Selections from '../Selections/Selections'
import { useAppDispatch, useAppSelector } from '../../hooks'

const UserConfiguration: React.FC = () => {
  const dispatch = useAppDispatch()

  const { meta, props, items } = useAppSelector((state) => state.configResult)
  const { assetBaseUrl, content } = useAppSelector((state) => state.init)
  useAppSelector((state) => state.selectedItem)
  const { selectedToolbarTabIndex } = useAppSelector((state) => state.ui)

  useEffect(() => {
    dispatch(setSelectedToolbarTabIndex(0))
  }, [dispatch])

  return (
    <Styled.Toolbar>
      {meta && props && items ? (
        <>
          <Tabs
            selectedIndex={selectedToolbarTabIndex}
            onSelect={(index) => {
              // if entering a tab
              dispatch(setSelectedToolbarTabIndex(index))
            }}
          >
            <ScrollButtons hideButtons={true}>
              <TabList>
                {content.tabs.map((tab: any, index: number) => (
                  <Tab key={tab.title + index}>
                    <img title={tab.title} alt={tab.title} src={`${assetBaseUrl}${tab.image}`} />
                    {tab.title}
                  </Tab>
                ))}
              </TabList>
            </ScrollButtons>

            <TabPanel>
              <Selections tab={'size'} />
            </TabPanel>
            <TabPanel>
              <Selections tab={'roof'} />
            </TabPanel>
            <TabPanel>
              <Selections tab={'loft'} />
            </TabPanel>
            <TabPanel>
              <Selections tab={'doors'} />
            </TabPanel>
            <TabPanel>
              <Selections tab={'windows'} />
            </TabPanel>
            <TabPanel>
              <Selections tab={'gates'} />
            </TabPanel>
            <TabPanel>
              <Selections tab={'options'} />
            </TabPanel>
          </Tabs>
          <EditItemPanel />
        </>
      ) : (
        <>
          <Skeleton width="90%" height="200px" />
        </>
      )}
    </Styled.Toolbar>
  )
}

export default UserConfiguration
